<div class="nopage-container h-screen flex flex-col justify-center items-center">
  <div class="w-full flex flex-col justify-center items-center">
    <p class="text-6xl">403</p>
    <p class="text-[1.4em]">{{ "nopage.forbidden_message" | transloco }}</p>
  </div>
  <div class="w-full mt-10 flex justify-center items-center">
    <p-button
      label="{{ 'nopage.buttons.goHome' | transloco }}"
      [link]="true"
      (click)="goHome()"
    ></p-button>
  </div>
</div>